import {Component, OnInit, ViewChild} from '@angular/core';
import {NavParams, NavController, App, AlertController, LoadingController, Events, Tabs} from 'ionic-angular';
import {HomePage} from '../home/home';
import {LotteryRecordPage} from '../lotteryRecord/lotteryRecord';
import {AgencyManagePage} from '../agencyManage/agencyManage';
import {UserPage} from "../user/user";
import {UserService} from "../../services/user.services";
import { IbcServices } from "../../services/ibc.services";
import {CommonService} from "../../services/common.service";
import {ThirdpartyGame} from "../thirdpartyGame/thirdpartyGame";
import {LoginPage} from "../login/login";

@Component({
    templateUrl: 'tabs.html'
})
export class TabsPage implements OnInit{
    @ViewChild('myTabs') tabRef: Tabs;

    paramUser: any;
    // this tells the tabs component which Pages
    // should be each tab's root Page
    tab1Root: any = HomePage;
    tab2Root: any = LotteryRecordPage;
    tab3Root: any = AgencyManagePage;
    tab4Root: any = UserPage;
    tabGames: any = ThirdpartyGame;
    public isAccountTest: boolean = true;
    static getCountUnReadMsg: number = 0;
    public getCountUnReadMsg: number = 0;
    static getMsgInterval: any;
    private slectedTabIdx: number = 0;

    constructor(private params: NavParams, private navCtrl: NavController, private app: App, private ibcService: IbcServices, public cs: CommonService,
                private userService: UserService, private alertCtrl: AlertController, private loadingCtrl: LoadingController, public event: Events) {
        if (params.data.hasOwnProperty('selectTab')) {
            this.slectedTabIdx = params.data["selectTab"];
        }
        this.paramUser = LoginPage.paramUserLogin;
        if (this.cs.userType > 1) {
            this.isAccountTest = false;
        }
    }

    switchTab(index: number) {
        this.tabRef.select(index);
      }
      ionViewDidEnter() {
        // const tabs = this.navCtrl.parent;
        const activeTabIndex = this.tabRef.getSelected().index;
        const tabIndex = this.params.get('tabIndex');
        // console.log('activeTabIndex',activeTabIndex,tabIndex);
        if (tabIndex !== undefined) {
            // if(activeTabIndex != 0)
          this.switchTab(tabIndex);
            this.params.data['tabIndex'] = undefined;

        }
      }
    ngOnInit() {
    }

    getMsgBadge() {
        this.getCountUnReadMsg = TabsPage.getCountUnReadMsg = 0;
        this.userService.personMessageSearch(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                let getArrData = data['reslist'];
                getArrData.map(item => {
                    if (item.status === 0) {
                        this.getCountUnReadMsg = TabsPage.getCountUnReadMsg += 1;
                    }
                });
                this.event.publish('countUnReadMsg:get', this.getCountUnReadMsg);
            }
        });
    }

    timerGetMsgBadge() {
        TabsPage.getMsgInterval = setInterval(() => {
            this.getMsgBadge();
        }, 10000);
    }

    ionViewWillLeave() {
        clearInterval(TabsPage.getMsgInterval);
        this.event.publish('getbalance:get');
    }

    ionViewWillEnter() {
        this.getMsgBadge();
        this.timerGetMsgBadge();
        this.event.publish('getbalance:get');
    }
}


// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts